import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import questions from '../../data/questions';
import { IAppState, IUserFormInput } from '../../types';
import {
  CardBody,
  CardHeader,
  QuestionTypography,
  StyledCard,
  SubQuestionTypography,
} from '../../styles/CardTextAndContainers';
import { isFinalQuestion } from '../../utils/progressUtils';
import { AppDispatch } from '../../reducers/appReducer';
import QuestionForm from '../forms/QuestionForm';

interface IProps {
  state: IAppState;
  dispatch: AppDispatch;
}

interface IParamTypes {
  id: string;
}

const QuestionCard = ({ state, dispatch }: IProps) => {
  const history = useHistory();
  const { id } = useParams<IParamTypes>();

  const cardData = questions[parseInt(id, 10)];

  const submitHandler = (userInput: IUserFormInput) => {
    dispatch({ type: 'setAnswers', payload: userInput });
    if (isFinalQuestion(state)) {
      dispatch({ type: 'finalize' });
      history.push('/results');
    } else {
      dispatch({ type: 'increment' });
      history.push(`${state.activeCard + 1}`);
    }
  };

  return (
    <StyledCard variant="outlined">
      <CardHeader>Stress-test your distributor&apos;s performance </CardHeader>
      <CardBody dangerouslySetInnerHTML={{ __html: cardData.bodyHTML }} />

      <QuestionTypography>{cardData.infoText}</QuestionTypography>

      {cardData.subInfoText && (
        <SubQuestionTypography>{cardData.subInfoText}</SubQuestionTypography>
      )}
      <QuestionForm
        submitHandler={submitHandler}
        cardData={cardData}
        state={state}
        dispatch={dispatch}
      />
    </StyledCard>
  );
};

export default QuestionCard;
